<div class="filter-button">
  <app-types-filter (filterChange)="onTypesFilterChange($event)"></app-types-filter>
  <app-users-filter [selectedTypeIds]="selectedTypeIds" (filterChange)="onUsersFilterChange($event)"></app-users-filter>
</div>
